import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export const routes = [
  {
    path: "/",
    redirect: "/home",
    meta: {
      title: "首页",
    },
    hidden: true,
  },
  {
    path: "/home",
    name: "home",
    component: (resolve) => require(["@/view/HomePage"], resolve),
    meta: {
      title: "首页",
    },
  },
  {
    path: "/about",
    name: "about",
    component: (resolve) => require(["@/view/About"], resolve),
    meta: {
      title: "关于我们",
    },
  },
  {
    path: "/news",
    name: "news",
    component: (resolve) => require(["@/view/News/list.vue"], resolve),
    meta: {
      title: "新闻动态",
    },
  },
  {
    path: "/news/detail",
    name: "news-detail",
    hidden: true,
    component: (resolve) => require(["@/view/News/detail.vue"], resolve),
    meta: {
      title: "新闻详情",
    },
  },
  {
    path: "/contactus",
    name: "contactus",
    component: (resolve) => require(["@/view/ContactUs"], resolve),
    meta: {
      title: "联系我们",
    },
  },
  {
    path: "/jobchance",
    name: "jobchance",
    component: (resolve) => require(["@/view/JobChance"], resolve),
    meta: {
      title: "加入我们",
    },
  },
];

export default new Router({
  routes: disintegrationRoutes(routes),
});

function disintegrationRoutes(routes, parentPath = "", auth = false) {
  const _routes = [];

  (function _disintegrationRoutes(routes, parentPath, auth, alive, lay = true) {
    routes.forEach((route) => {
      let { path, children, meta = {}, ...other } = route;
      let { requireAuth, keepAlive, layout } = meta;

      if (!requireAuth) {
        requireAuth = auth;
      }

      if (keepAlive === void 0) {
        keepAlive = alive;
      }

      if (layout === void 0) {
        layout = lay;
      }

      if (path.indexOf("/") != 0) {
        path = parentPath.concat("/", path);
      }

      _routes.push({
        name: path.substr(1),
        ...other,
        path,
        meta: { ...meta, requireAuth, keepAlive, layout },
      });

      if (children) {
        _disintegrationRoutes(children, path, requireAuth, keepAlive, layout);
      }
    });
  })(routes, parentPath, auth);

  return _routes;
}



// WEBPACK FOOTER //
// ./src/router/index.js